
import { defineComponent } from 'vue'
import { Container } from '@/components/bosons'
import { Header, Presentation, Services } from '@/components/organisms'

export default defineComponent({
  components: {
    Header,
    Presentation,
    Services,
    Container
  }
})
